import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CompetitionService } from '@b2b/core/api/competition/competition.service';

import { Slide, Badge } from '@sparro/app/core/models/carousel.model';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { MetaDefinition } from '@angular/platform-browser';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';

import { environment } from '@b2b/env/environment';
import _ from 'lodash';

@Component({
  selector: 'app-section-detail',
  templateUrl: './section-detail.component.html',
  styleUrls: ['./section-detail.component.scss']
})
export class SectionDetailComponent implements OnInit {
  section: any;
  carousel: Array<Slide> = [];
  // display = 'breakpoint';
  display = 'grid';
  isLoading: boolean = true;
  sectionPage: number = 1;
  page: number = 1;
  limit: number;

  constructor(
    private competitionService: CompetitionService,
    private route: ActivatedRoute,
    public router: Router,
    private imageOptimizer: ImageOptimizerService,
    public metaService: MetaService,
  ) { }

  ngOnInit() {
    const slug = this.route.snapshot.params.slug;
    this.getSectionDetail(slug);
  }

  getSectionDetail(slug) {
    this.competitionService.getSectionDetail(slug).subscribe(
      (response: any) => {
        this.section = response;
        this.isLoading = false;
        this.updateMetaInfo();
      },
      (err) => {
        console.log(err)
        this.isLoading = false;
      })
  }

  updateMetaInfo() {
    let metaInfo: MetaDefinition[] = [];
    let title: string,
      image: string,
      description: string;
    title = `UNI | ${this.section.title}`;
    description = `${this.section.description}`;
    this.carousel[0].image ? image = this.renderImage(this.carousel[0].image) : '';

    metaInfo = [
      { name: 'title', content: title },
      { name: 'description', content: description },
      { name: 'url', content: window.location.href },
      { name: 'image', content: image },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description.slice(0, 100) },
      { name: 'twitter:url', content: window.location.href },
      { name: 'twitter:image', content: image },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: window.location.href },
      { property: 'og:image', content: image },
      { property: 'og:image:alt', content: title },
      { property: 'og:type', content: 'website' }
    ];
    metaInfo.forEach(meta => {
      this.metaService.updateMetaInfo(meta);
    });
    this.metaService.updateMeta(metaInfo);
    this.metaService.updateTitle(title);
    this.metaService.createCanonicalURL();
  }

  renderImage(image) {
    return this.imageOptimizer.renderImage(image, window.innerWidth, window.innerHeight);
  }

  goToSearchPage(searchText: (string | void)): void {
    if (searchText) {
      this.router.navigate(['search'], {
        queryParams: {
          query: searchText,
        },
      });
    }
    else {
      this.router.navigate(['search']);
    }
  }
}
